import React, { useContext, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import CTextBox from '../../../../../Common/CTextBox';
import ToolBar from '../../../../../Common/Toolbar';
import './style.css';
import { setBoardComponentComment } from '../../../../../../services/sKPI/board.service';
import moment from 'moment';
import MainAppContext from '../../../../../../MainAppContext';

function INFO_CUSTOMTEXT(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    const { 
        inputParam_ElementId = null,
        inputParam_Item = null,
        inputParam_FontSize = "16px",
	      inputParam_Component = null
    } = props;

    const [readOnly, setReadOnly] = useState(true);
    const [readOnlyTitle, setReadOnlyTitle] = useState(true);
    
    const [baseTextId, setBaseTextId] = useState(inputParam_Item ? inputParam_Item.id : 0);
    const [baseText, setBaseText] = useState(inputParam_Item ? inputParam_Item.value : '');
    const [baseTitle, setBaseTitle] = useState(!isNullUndefinedOrEmpty(inputParam_Item && inputParam_Item.title) ? inputParam_Item.title : t('data-lang-lbl-title'));
    
    const onEditTitle = () => {
      	setReadOnlyTitle(!readOnlyTitle)
    }

    const onEditText = () => {
      	setReadOnly(!readOnly)
    }

    const onSaveTitle = () => {
      	setReadOnlyTitle(true)
    }

    const onSaveText = () => {
      setBoardComponentComment(inputParam_ElementId, 0, inputParam_Component.id, baseTextId, baseText, moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).toDate()).then((response) => {
        if (response.data.succeeded) {
          setBaseTextId(response.data.data)
          setReadOnly(true)
        }
        else {
          setReadOnly(false)
        }
      }).catch(() => {
          setReadOnly(false)
      });
    }

    const onCancelTitle = () => {
		setBaseTitle(!isNullUndefinedOrEmpty(inputParam_Item.title) ? inputParam_Item.title : t('data-lang-lbl-title'))
		setReadOnlyTitle(true)
    }

    const onCancelText = () => {
		setBaseText(inputParam_Item.value)
		setReadOnly(true)
    }
    
    const overflowItems = [
		/*{
			key: 'editTitle',
			text: t('data-lang-btn-edittitle'),
			iconProps: { iconName: 'WindowEdit' },
			onClick: onEditTitle,
			hidden: !readOnlyTitle
		},{
			key: 'editTitleSave',
			text: t('data-lang-btn-savetitle'),
			iconProps: { iconName: 'Save' },
			onClick: onSaveTitle,
			hidden: readOnlyTitle
		},{
			key: 'cancelTitle',
			text: t('data-lang-btn-canceltitle'),
			iconProps: { iconName: 'Cancel' },
			onClick: onCancelTitle,
			hidden: readOnlyTitle
		},*/{
			key: 'editText',
			text: t('data-lang-btn-edittext'),
			iconProps: { iconName: 'EditNote' },
			onClick: onEditText,
			hidden: !readOnly
		},{
			key: 'editTextSave',
			text: t('data-lang-btn-savetext'),
			iconProps: { iconName: 'Save' },
			onClick: onSaveText,
			hidden: readOnly
		},{
			key: 'cancelText',
			text: t('data-lang-btn-canceltext'),
			iconProps: { iconName: 'Cancel' },
			onClick: onCancelText,
			hidden: readOnly
		}
    ]

    return (
      <>
        {
          inputParam_Item &&
          <Card className={`${(!readOnlyTitle) ? '' : 'h-100'} p-0 m-0`}
            data-container-id={!isNullUndefined(inputParam_Component) ? inputParam_Component.containerId : ''}
            data-component-id={!isNullUndefined(inputParam_Component) ? inputParam_Component.id : ''}
          >
              <div className={`${(!readOnlyTitle) ? '' : 'h-50'} border-bottom`} style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                <Row>
                  <Col>
                    {
                      readOnlyTitle &&
                      <>
                        { baseTitle }
                      </>
                    }
                    {
                      !readOnlyTitle &&
                      <CTextBox isInValid={ isNullUndefinedOrEmpty(baseTitle) } setterControlValue={ setBaseTitle } controlValue={ baseTitle }></CTextBox>
                    }
                  </Col>
                  <Col className='col-auto me-auto mt-1 report-command-bar'>
                    <ToolBar overflowItems={ overflowItems } styles={{root: {height: "15px", backgroundColor: "transparent"}}} display={ true } />
                  </Col>
                </Row>
              </div>
              <Card.Body className={`${(!readOnlyTitle) ? '' : 'h-50'} p-0 m-0 text-center rounded-top`}>
                {
                  readOnly &&
                  <b style={{fontSize: inputParam_FontSize}}>{ isNullUndefinedOrEmpty(baseText) ? t('data-lang-lbl-nodata') : `${baseText}` }</b>
                }
                {
                  !readOnly &&
                  <CTextBox isInValid={ isNullUndefinedOrEmpty(baseText) } setterControlValue={ setBaseText } controlValue={ baseText }></CTextBox>
                }
                </Card.Body>
          </Card>
        }
      </>
    );
}

INFO_CUSTOMTEXT.propTypes = {
  inputParam_Item: PropTypes.object.isRequired,
  inputParam_FontSize: PropTypes.string,
};

export default INFO_CUSTOMTEXT;